@switch (context ? context.type : '') {
    @default {
        <fui-edit-search-input [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                               (focussed$)="onFocussed($event)"
                               [placeholder]="placeholder"></fui-edit-search-input>
    }
    @case (contextType.FILTER) {
        <fui-filter-search-input [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                                 (focussed$)="onFocussed($event)"
                                 [placeholder]="placeholder"></fui-filter-search-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-search-input (focussed$)="onFocussed($event)"></fui-inline-search-input>
    }
    @case (contextType.POP) {
        <fui-pop-search-input [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                              (focussed$)="onFocussed($event)"
                              [placeholder]="placeholder"></fui-pop-search-input>
    }
    @case (contextType.PILL) {
        <fui-search-pill [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                         (focussed$)="onFocussed($event)"
                         [removable]="removable" (removed$)="remove()" [placeholder]="placeholder"
        ></fui-search-pill>
    }
}
